import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

var _templateObject, _templateObject2;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import { sharedDefaultProps, sharedPropTypes } from '../utilities';
import styled from 'styled-components';
import { ColorTokens } from '@vds-tokens/color';
import { AccessibilityTokens } from '@vds-tokens/accessibility';
import { TypographyTokens } from '@vds-tokens/typography';
import { Fonts } from '@vds-core/typography';
import { calculateRem } from '@vds-core/utilities';

var propTypes = _objectSpread(_objectSpread({}, sharedPropTypes), {}, {
  /**
   * @ignore
   */
  children: PropTypes.node,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * @ignore
   */
  linkStyles: PropTypes.object,

  /**
   * Border radius for focus ring
   */
  focusBorderRadius: PropTypes.string
});

var defaultProps = _objectSpread(_objectSpread({}, sharedDefaultProps), {}, {
  children: null,
  className: null,
  linkStyles: null
});

var colorLink = ColorTokens.elements.primary.onlight.value;
var colorLinkInverted = ColorTokens.elements.primary.ondark.value;
var fontWeightBold = TypographyTokens.fontweight.bold.value;
var fontFamily = Fonts.VerizonNHGeTX;
var fontSizeDesktop = TypographyTokens.fontsize.body[12].value;
var lineHeightDesktop = TypographyTokens.lineheight.body[16].value;
var StyledLink = /*#__PURE__*/styled.a.withConfig({
  displayName: "StyledLink",
  componentId: "VDS__sc-dbm2b9-0"
})(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  background-color: transparent;\n  border: none;\n  color: ", ";\n  cursor: pointer;\n  display: block;\n  font-family: ", ";\n  font-size: ", "; // TODO: Viewport awareness?\n  line-height: ", ";\n  text-decoration: none;\n  width: 100%;\n  position: relative;\n  ", "\n\n  &:active,\n  &:hover {\n    outline: none;\n    span {\n      outline: none;\n    }\n  }\n\n  ", ";\n"])), function (_ref) {
  var surface = _ref.surface;
  return surface === 'dark' ? colorLinkInverted : colorLink;
}, fontFamily, fontSizeDesktop, lineHeightDesktop, function (_ref2) {
  var focusBorderRadius = _ref2.focusBorderRadius,
      surface = _ref2.surface,
      active = _ref2.active;
  return !active && "\n    &:focus:not(:active) {\n        outline: none;\n        span {\n          &::after {\n            border: ".concat(calculateRem(AccessibilityTokens.width.focusring.value), " ").concat(AccessibilityTokens.borderstyle.focusring.value, "\n            border-color: ").concat(surface === 'dark' ? AccessibilityTokens.color.focusring.ondark.value : AccessibilityTokens.color.focusring.onlight.value, "\n            border-radius: ").concat(focusBorderRadius, ";\n            content: '';\n            position: absolute;\n            height: 20px;\n            width: calc(100% + ").concat(calculateRem(parseInt(AccessibilityTokens.space.focusringoffset.value) + parseInt(AccessibilityTokens.width.focusring.value)), ");\n          }\n        }\n      }\n    }\n  ");
}, function (_ref3) {
  var active = _ref3.active;
  return active && "\n    outline: none;\n    font-weight: ".concat(fontWeightBold, ";\n  ");
});
var ScreenReaderText = /*#__PURE__*/styled.span.withConfig({
  displayName: "ScreenReaderText",
  componentId: "VDS__sc-dbm2b9-1"
})(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border: 0;\n"])));
/**
 * @ignore
 */

var PaginationLink = function PaginationLink(props) {
  var baseUrl = props.baseUrl,
      children = props.children,
      className = props.className,
      selectedPage = props.selectedPage,
      linkStyles = props.linkStyles,
      onClick = props.onClick,
      pageNumberProp = props.pageNumber,
      cta = props.cta,
      position = props.position,
      level = props.level,
      dataTrack = props.dataTrack,
      surface = props.surface,
      focusBorderRadius = props.focusBorderRadius,
      total = props.total;

  function _onClick(e) {
    if (e.key === 'Enter' || e.type === 'click' || e.key === ' ') {
      e.preventDefault();
      onClick(pageNumberProp, e);
    }
  }

  var isActive = selectedPage === pageNumberProp;
  var baseUrlString = baseUrl && pageNumberProp ? baseUrl(pageNumberProp) : undefined; //there is only a predefined aria label on first and last elements

  return /*#__PURE__*/React.createElement(StyledLink, {
    active: isActive,
    surface: surface,
    focusBorderRadius: focusBorderRadius,
    "aria-label": props['aria-label'] ? props['aria-label'] : "Go to Page ".concat(pageNumberProp, " of ").concat(total),
    className: className,
    href: baseUrlString,
    style: linkStyles,
    onClick: !baseUrlString ? _onClick : baseUrl,
    onKeyDown: !baseUrlString ? _onClick : baseUrl,
    tabIndex: isActive ? -1 : 0,
    "data-sitecat-cta": cta,
    "data-sitecat-position": position,
    "data-sitecat-level": level,
    "data-sitecat-datatrack": dataTrack
  }, children, /*#__PURE__*/React.createElement(ScreenReaderText, {
    "aria-live": isActive && 'assertive'
  }, isActive && "Page ".concat(pageNumberProp, " selected")));
};

PaginationLink.propTypes = propTypes;
PaginationLink.defaultProps = defaultProps;
export default PaginationLink;